import { clickEventService } from './click-event-service';
import { ClickEventHelperDom } from './click-event-helper-dom';

class ClickEventObjectDefault {
	/**
	 * registers to ClickEventService
	 * @constructor singleton
	 */
	constructor() {
		if (ClickEventObjectDefault._instance) {
			return ClickEventObjectDefault._instance;
		}

		clickEventService.register(ClickEventObjectDefault.getData, true);

		ClickEventObjectDefault._instance = this;
	}

	/**
	 * getData - collects the tracking data
	 * @param {JSON} eventData_ - event data
	 * @returns {Promise} promise - returns promise for linkObject
	 */
	static async getData(eventData_) {
		let linkObject = {
			eventInfo: {
				eventAction: 'internal_link',
				eventName: 'generic',
			},
			attributes: {
				componentName: eventData_.moduleName,
				label: ClickEventHelperDom.getLabel(eventData_),
				currentURL: eventData_.currentURL,
				targetURL: ClickEventHelperDom.getTargetUrl(eventData_),
				clickID: ClickEventHelperDom.getClickID(eventData_),
				elementName: ClickEventHelperDom.getElementName(eventData_),
				value: '',
				pos: '',
			},
		};

		return linkObject;
	}
}

/**
 * Singleton instance
 * @type {ClickEventObjectDefault}
 * @private
 * @static
 */

const clickEventObjectDefault = new ClickEventObjectDefault();

export { clickEventObjectDefault, ClickEventObjectDefault };
